import { SITE_URL } from 'libs/constants'

export const removeQueryParams = (str: string) =>
  str.split('?')[0].split('#')[0]

export const getUrlWithoutQueryParams = (path: string) =>
  `${SITE_URL}${removeQueryParams(path)}`

type Params = Array<[string, string]>
export const buildQueryParams = (params: Params) =>
  params.map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')

// SITE_URL is only a parse base for relative hrefs; the origin is dropped again.
const parse = (href: string) => new URL(href, SITE_URL)
const serialize = (url: URL) => `${url.pathname}${url.search}`

export const getPathname = (href: string) => parse(href).pathname

export const withQueryParam = (href: string, key: string, value: string) => {
  const url = parse(href)
  url.searchParams.set(key, value)
  return serialize(url)
}

export const withoutQueryParam = (href: string, key: string) => {
  const url = parse(href)
  url.searchParams.delete(key)
  return serialize(url)
}
